// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { AiOutlineClose } from "react-icons/ai";
// import { RiMenu3Line } from "react-icons/ri";
// import Sports from "../HeaderContent/Sports";
// import AccountSec from "../HeaderContent/AccountSec";
// import "../Css/fonts.css";
// import { Link, useNavigate } from "react-router-dom";
// import {
//   getCart,
//   menuSection,
//   menuSlugSection,
//   productApi,
// } from "../../Services/Operations/ProductAPI";
// import { AiOutlineDown } from "react-icons/ai";
// import "../../Styles/Header.css";
// import { toast } from "react-toastify";
// import debounce from "lodash/debounce";
// import { useSelector } from "react-redux";
// import { FaRegHeart } from "react-icons/fa6";
// import { FiShoppingCart } from "react-icons/fi";

// function Header() {
//   const [image17Loaded, setImage17Loaded] = useState(false);
//   const [image21Loaded, setImage21Loaded] = useState(false);
//   const staticMenu = [
//     { id: 1, name: "Men", slug: "men" },
//     { id: 2, name: "Women", slug: "women" },
//     { id: 3, name: "Kids", slug: "kids" },
//     { id: 4, name: "Team Order", slug: "team-order" },
//     { id: 5, name: "Family Order", slug: "family-order" },
//     { id: 6, name: "Design your own", slug: "design-your-own" },
//   ];

//   const staticCategory = [
//     {
//       id: 1,
//       name: "Badminton",
//       slug: "men-badminton",
//       subcategory: [
//         { id: 22, name: "Jersey", slug: "men-jersey" },
//         { id: 23, name: "Shorts", slug: "men-shorts" },
//         { id: 24, name: "Tank top", slug: "men-tank-top" },
//       ],
//     },
//     {
//       id: 2,
//       name: "Cycling",
//       slug: "men-cycling",
//       subcategory: [
//         { id: 25, name: "Cycling Jersey", slug: "men-cycling-jersey" },
//         { id: 26, name: "Race fit jersey", slug: "men-race-fit-jersey" },
//         { id: 27, name: "Winter jersey", slug: "men-winter-jersey" },
//         { id: 29, name: "Shorts", slug: "men-cycling-shorts" },
//         { id: 30, name: "Tees", slug: "men-tees" },
//       ],
//     },
//     {
//       id: 3,
//       name: "Cricket",
//       slug: "men-cricket",
//       subcategory: [
//         { id: 31, name: "City collection", slug: "men-city-collection" },
//         { id: 32, name: "Jersey", slug: "men-cricket-jersey" },
//         { id: 33, name: "Shorts", slug: "men-cricket-shorts" },
//         { id: 34, name: "Track pants", slug: "men-track-pants" },
//         { id: 35, name: "Whites", slug: "men-whites" },
//       ],
//     },
//     {
//       id: 4,
//       name: "Running",
//       slug: "men-running",
//       subcategory: [
//         { id: 36, name: "X jersey", slug: "men-x-jersey" },
//         { id: 37, name: "Pro jersey", slug: "men-pro-jersey" },
//         {
//           id: 38,
//           name: "Pro tank top jersey",
//           slug: "men-pro-tank-top-jersey",
//         },
//         { id: 39, name: "Shorts", slug: "men-running-shorts" },
//       ],
//     },
//     {
//       id: 5,
//       name: "Fitness",
//       slug: "men-fitness",
//       subcategory: [
//         { id: 40, name: "Basic T shirt", slug: "men-basic-t-shirt" },
//         { id: 41, name: "Pro T shirt", slug: "men-pro-t-shirt" },
//         { id: 42, name: "Woven Shorts", slug: "men-woven-shorts" },
//         { id: 43, name: "Compression pants", slug: "men-compression-pants" },
//         { id: 44, name: "Knitted shorts", slug: "men-knitted-shorts" },
//         {
//           id: 45,
//           name: "Fitness Pro T shirt",
//           slug: "men-fitness-pro-t-shirt",
//         },
//         { id: 46, name: "Singlet", slug: "men-singlet" },
//       ],
//     },
//     {
//       id: 6,
//       name: "Basketball",
//       slug: "men-basketball",
//       subcategory: [
//         { id: 47, name: "Arm sleeves", slug: "men-arm-sleeves" },
//         { id: 48, name: "Jersey", slug: "men-basketball-jersey" },
//         { id: 49, name: "Shorts", slug: "men-basketball-shorts" },
//       ],
//     },
//     {
//       id: 7,
//       name: "Football",
//       slug: "men-football",
//       subcategory: [
//         { id: 50, name: "Jersey", slug: "men-football-jersey" },
//         { id: 51, name: "Shorts", slug: "men-football-shorts" },
//       ],
//     },
//   ];
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null);
//   // const { tokenDetails } = useSelector((state) => state.user);
//   const [menu, setMenu] = useState(staticMenu);
//   const [menuSlugName, setMenuSlugName] = useState("");
//   const [menuSubcategory, setmenuSubcategory] = useState("");
//   const [menuSlug, setMenuSlug] = useState(staticCategory);
//   const [product, setProduct] = useState([]);
//   const [cartProduct, setCartProduct] = useState([]);
//   const [glb, setGlb] = useState([]);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [hoveredItemIndex, setHoveredItemIndex] = useState(null);
//   const { favorites } = useSelector((state) => state.cart);
//   const totalFavorites = favorites.length;
//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen(!isMobileMenuOpen);
//   };
//   const { totalItems } = useSelector((state) => state.cart);
//   console.log("totalItems : ", totalItems);
//   const { tokenDetails } = useSelector((state) => state.user);

//   const handle3d = () => {
//     console.log("Don");
//     if (!tokenDetails) {
//       //toast.error("User not found. Please login.");
//       return;
//     }
//     navigate("/3d-product");
//   };

//   const [clickedSubItemId, setClickedSubItemId] = useState(null);

//   const [clickedItemIndex, setClickedItemIndex] = useState(null);

//   const clickHandler = async (name, slug) => {
//     try {
//       setMenuSlug("");
//       console.log("enter name : ", slug);
//       setMenuSlugName(slug);
//       const formData = new FormData();
//       formData.append("slug", slug);
//       const response = await menuSlugSection(formData);
//       console.log("API response:", response.data.category);
//       if (response.success === true) {
//         setMenuSlug(response.data.category);
//       }
//     } catch (error) {
//       console.error("Error during API call:", error);
//     }
//   };

//   const clickProductHandler = async (name, menu, categoryName) => {
//     if (!menuSlugName || !name) {
//       console.error("Invalid slugs provided:", { menuSlugName, name });
//       return;
//     }

//     try {
//       console.log("menuSlug:", menuSlugName, "categorySlug:", name);
//       console.log("categoryName : ", categoryName);
//       const formData = new FormData();
//       formData.append("menuSlug", menuSlugName);
//       formData.append("categorySlug", name);

//       const response = await productApi(formData);
//       console.log("API response for product:", response);

//       if (response.success && response.data) {
//         setProduct(response.data);

//         console.log("Navigating to productListing with data:", response.data);
//         setClickedItemIndex(null);
//         navigate("/productListing", {
//           state: {
//             productData: response.data,
//             menu: menu,
//             categoryName: categoryName,
//           },
//         });

//         // const productData = encodeURIComponent(JSON.stringify(response.data));
//         // window.location.href = `/productListing?productData=${productData}`;
//       } else {
//         console.error("Product API response invalid or empty");
//         setClickedItemIndex(null);
//         navigate("/productListing", {
//           state: {},
//         });
//         //toast.error("Product not found");
//       }
//     } catch (error) {
//       console.error("Error during product API call:", error);
//     }
//   };

//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setClickedItemIndex(null); // Close dropdown
//       }
//     };

//     if (clickedItemIndex !== null) {
//       document.addEventListener("mousedown", handleOutsideClick);
//     } else {
//       document.removeEventListener("mousedown", handleOutsideClick);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleOutsideClick);
//     };
//   }, [clickedItemIndex]);

//   const ImageSkeleton = ({ width = "150px", height = "300px" }) => {
//     return (
//       <div
//         style={{
//           width,
//           height,
//           background:
//             "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//           backgroundSize: "200% 100%",
//           animation: "shimmer 1.5s infinite",
//         }}
//       />
//     );
//   };

//   return (
//     <div>
//       <div class="marquee">
//         <div
//           class="countdown-timer-block"
//           countdown-timer-id="cm3rbzmai22618019vi59rr7ju5"
//         ></div>
//         <div class="announcment_bar">
//           <b class="marqee-animation">
//             <span>
//               FLAT $500/- OFF ALL PRE-PAID ORDERS TILL 11:11PM (ONLY FOR TODAY)
//               <br />
//               FLAT $500/- OFF ALL PRE-PAID ORDERS TILL 11:11PM (ONLY FOR TODAY)
//             </span>
//           </b>
//         </div>
//       </div>
//       <header
//         className="header-main"
//         style={{ position: "fixed", top: "0px", width: "100%" }}
//       >
//         <div className="block-container-2 header-block">
//           <div
//             className={`header-full-section align-items-center header-row ${
//               isMobileMenuOpen ? "mobile-align-items-center" : ""
//             }`}
//           >
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <div className="d-icon">
//                 <div className="menu-button f_menuActionContainer">
//                   <button
//                     className={`${
//                       isMobileMenuOpen
//                         ? "mobile-icon-btn"
//                         : "btn nav-main-toggle-btn header-actions-btn"
//                     }`}
//                     onClick={toggleMobileMenu}
//                     aria-label="Menu"
//                   >
//                     {isMobileMenuOpen ? (
//                       <AiOutlineClose
//                         className="icon-close"
//                         style={{ color: "black" }}
//                       />
//                     ) : (
//                       <RiMenu3Line
//                         className="icon-burger-menu"
//                         style={{ color: "black" }}
//                       />
//                     )}
//                   </button>
//                 </div>
//               </div>
//               <div
//                 className="header-logo-col"
//                 style={{
//                   width: "max-content",
//                   position: "relative",
//                   margin: "0px",
//                 }}
//               >
//                 <div className="header-logo-main">
//                   <Link to="/">
//                     <img
//                       className="header-logo-img"
//                       src="/asset/LogoSports.png"
//                       alt="Sports"
//                       width="100%"
//                       height="50"
//                     />
//                   </Link>
//                 </div>
//               </div>
//             </div>

//             <div
//               className={`${
//                 isMobileMenuOpen
//                   ? "show-mobile-menu header-nav-box open"
//                   : "header-nav-box"
//               }`}
//             >
//               <div className="main-navigation d-lg-block" id="mainNavigation">
//                 <div className="container">
//                   <nav
//                     className="nav main-navigation-menu default"
//                     itemScope="itemscope"
//                     itemType="http://schema.org/SiteNavigationElement"
//                   >
//                     <div className="main-navigation-menu-container">
//                       <div style={{ width: "100%" }}>
//                         <div
//                           className="nav-link main-navigation-link"
//                           title="Sports"
//                           style={{ width: "100%", padding: "0px" }}
//                         >
//                           <div
//                             className={`${
//                               isMobileMenuOpen
//                                 ? "main-navigation-link-text mobile-main-navigation-link-text"
//                                 : "main-navigation-link-text"
//                             }`}
//                           >
//                             {menu?.map((item1, index) => (
//                               <div
//                                 className={`${
//                                   item1.name === "Design your own"
//                                     ? "design-your-own"
//                                     : ""
//                                 }`}
//                                 key={index}
//                                 style={{
//                                   display: "flex",
//                                   gap: "10px",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                   position: "relative",
//                                   padding: "14px 10px",
//                                 }}
//                                 onMouseEnter={() => {
//                                   setHoveredItemIndex(index);
//                                   if (
//                                     item1.name !== "Design your own" ||
//                                     item1.name !== "Team Order" ||
//                                     item1.name !== "Family Order"
//                                   ) {
//                                     clickHandler(item1.name, item1.slug);
//                                   }
//                                   // else{
//                                   //  handle3d();
//                                   // }
//                                 }}
//                                 onMouseLeave={() => setHoveredItemIndex(null)}
//                                 ref={
//                                   hoveredItemIndex === index
//                                     ? dropdownRef
//                                     : null
//                                 }
//                                 onClick={() => {
//                                   if (item1.name === "Design your own") {
//                                     handle3d();
//                                   } else if (item1.name === "Team Order") {
//                                     navigate("/team-order");
//                                   } else if (item1.name === "Family Order") {
//                                     navigate("/family-order");
//                                   }
//                                 }}
//                               >
//                                 {/* {item1.name === "Design your own" && (
//                                   <div className="yellow-bg"></div>
//                                 )} */}
//                                 <span
//                                   style={{
//                                     color: "black",
//                                     width: "100%",
//                                     fontSize: "14px",
//                                     fontWeight: "bold",
//                                     position: "relative",
//                                   }}
//                                 >
//                                   {item1.name}
//                                   {hoveredItemIndex === index && (
//                                     <div
//                                       style={{
//                                         position: "absolute",
//                                         bottom: "-5px",
//                                         left: "0",
//                                         width: "100%",
//                                         height: "3px",
//                                         backgroundColor: "black",
//                                       }}
//                                     />
//                                   )}
//                                 </span>

//                                 {(item1.name !== "Design your own" ||
//                                   item1.name !== "Team Order" ||
//                                   item1.name !== "Family Order") &&
//                                   hoveredItemIndex === index &&
//                                   menuSlug.length > 0 && (
//                                     <ul
//                                       className={`dropdown-menu1 ${
//                                         hoveredItemIndex === index ? "show" : ""
//                                       }`}
//                                       style={{
//                                         position: "fixed",
//                                         top: "50px",
//                                         left: "0",
//                                         right: "0",
//                                         zIndex: 10,
//                                         backgroundColor: "#fff",
//                                         boxShadow:
//                                           "0px 4px 6px rgba(0, 0, 0, 0.1)",
//                                         padding: "20px",
//                                         width: "100%",
//                                         height: "350px",

//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "space-between",
//                                         flexDirection: "row",
//                                       }}
//                                     >
//                                       <div
//                                         className="dropdown-height"
//                                         style={{
//                                           display: "flex",
//                                           flexDirection: "column",
//                                           flexWrap: "wrap",
//                                           height: "100%",
//                                         }}
//                                       >
//                                         {menuSlug?.map((item) => (
//                                           <li
//                                             key={item.id}
//                                             className="dropdown-item"
//                                           >
//                                             <div className="deropdown-item-list">
//                                               <strong
//                                                 onClick={() => {
//                                                   setmenuSubcategory(item.slug);
//                                                   clickProductHandler(
//                                                     item.slug,
//                                                     item1.slug,
//                                                     item.slug
//                                                   );
//                                                   setHoveredItemIndex(null);
//                                                 }}
//                                                 style={{
//                                                   fontSize: "12px",
//                                                   color: "black",
//                                                 }}
//                                               >
//                                                 {item.name}
//                                               </strong>
//                                               <ul className="list-unstyled">
//                                                 {item.subcategory?.map(
//                                                   (subItem) => (
//                                                     <li
//                                                       key={subItem.id}
//                                                       className={
//                                                         clickedSubItemId ===
//                                                         subItem.id
//                                                           ? "bg-blue"
//                                                           : ""
//                                                       }
//                                                     >
//                                                       <a
//                                                         className="text-decoration-none sub-item-link"
//                                                         onClick={() => {
//                                                           setmenuSubcategory(
//                                                             subItem.slug
//                                                           );
//                                                           clickProductHandler(
//                                                             subItem.slug,
//                                                             item1.slug,
//                                                             item.slug
//                                                           );
//                                                           setHoveredItemIndex(
//                                                             null
//                                                           ); // Close dropdown after click
//                                                         }}
//                                                         style={{
//                                                           fontSize: "12px",
//                                                         }}
//                                                       >
//                                                         {subItem.name}
//                                                       </a>
//                                                     </li>
//                                                   )
//                                                 )}
//                                               </ul>
//                                             </div>
//                                           </li>
//                                         ))}
//                                       </div>
//                                       <div
//                                         style={{ display: "flex", gap: "10px" }}
//                                       >
//                                         <div
//                                           className="dropdown-image"
//                                           style={{ position: "relative" }}
//                                         >
//                                           {!image17Loaded && <ImageSkeleton />}
//                                           <img
//                                             src="/asset/img/Ecom/17.webp"
//                                             alt="Product"
//                                             style={{
//                                               objectFit: "cover",
//                                               height: "300px",
//                                               display: image17Loaded
//                                                 ? "block"
//                                                 : "none",
//                                             }}
//                                             onLoad={() =>
//                                               setImage17Loaded(true)
//                                             }
//                                           />
//                                         </div>

//                                         <div
//                                           className="dropdown-image"
//                                           style={{ position: "relative" }}
//                                         >
//                                           {!image21Loaded && <ImageSkeleton />}
//                                           <img
//                                             src="/asset/img/Ecom/21.webp"
//                                             alt="Product"
//                                             style={{
//                                               objectFit: "cover",
//                                               height: "300px",
//                                               display: image21Loaded
//                                                 ? "block"
//                                                 : "none",
//                                             }}
//                                             onLoad={() =>
//                                               setImage21Loaded(true)
//                                             }
//                                           />
//                                         </div>
//                                       </div>
//                                     </ul>
//                                   )}
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </nav>
//                 </div>
//               </div>
//             </div>

//             <div
//               className={`header-action-box ${
//                 isMobileMenuOpen
//                   ? "header-action-box mobile-header-action-box"
//                   : ""
//               }`}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 marginLeft: "0px",
//                 flexDirection: "row-reverse",
//               }}
//             >
//               <AccountSec />
//               <div
//                 className="boxHover-container"
//                 onClick={() => (window.location.href = "/cart")}
//                 style={{
//                   cursor: "pointer",
//                   width: "25px",
//                   height: "29px",
//                   position: "relative",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <FiShoppingCart />

//                 {totalItems > 0 && (
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: "-13px",
//                       right: "-14px",
//                       backgroundColor: "#ff0000",
//                       color: "white",
//                       borderRadius: "50%",
//                       padding: "0 6px",
//                       fontSize: "12px",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {totalItems}
//                   </div>
//                 )}
//               </div>
//               <div
//                 className="boxHover-container"
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   width: "25px",
//                   height: "29px",
//                   position: "relative",
//                 }}
//                 onClick={() => navigate("/wishlist")}
//               >
//                 <FaRegHeart />

//                 {totalFavorites > 0 && (
//                   <div
//                     style={{
//                       position: "absolute",
//                       top: "-13px",
//                       right: "-14px",
//                       backgroundColor: "#ff0000",
//                       color: "white",
//                       borderRadius: "50%",
//                       padding: "0 6px",
//                       fontSize: "12px",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {totalFavorites}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>
//     </div>
//   );
// }

// export default Header;

import React, { useEffect, useState, useRef, useCallback } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { RiMenu3Line } from "react-icons/ri";
import Sports from "../HeaderContent/Sports";
import AccountSec from "../HeaderContent/AccountSec";
import "../Css/fonts.css";
import "../../Styles/All.css";
import { Link, useNavigate } from "react-router-dom";
import {
  getCart,
  menuSection,
  menuSlugSection,
  offer_Api,
  productApi,
} from "../../Services/Operations/ProductAPI";
import { AiOutlineDown } from "react-icons/ai";
import "../../Styles/Header.css";
import { toast } from "react-toastify";
import { motion ,AnimatePresence } from "framer-motion";
import debounce from "lodash/debounce";
import { useDispatch, useSelector } from "react-redux";
import { FaRegHeart } from "react-icons/fa6";
import { FiShoppingCart } from "react-icons/fi";
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";
import { MdOutlineMenu } from "react-icons/md";
import { FaTimes } from "react-icons/fa";
import { SiWhatsapp } from "react-icons/si";
import { color } from "framer-motion";
import { increaseModelItems } from "../../Redux/Cart_System";
import state from "../index.js";

function Header() {
  const [image17Loaded, setImage17Loaded] = useState(false);
  const [image21Loaded, setImage21Loaded] = useState(false);
  const staticMenu = [
    { id: 1, name: "Men", slug: "men" },
    { id: 2, name: "Women", slug: "women" },
    { id: 3, name: "Kids", slug: "kids" },
    { id: 4, name: "Team Order", slug: "team-order" },
    // { id: 5, name: "Event Order", slug: "event-order" },
    { id: 6, name: "Design your own", slug: "design-your-own" },
  ];

  const staticCategory = [
    {
      id: 1,
      name: "Badminton",
      slug: "men-badminton",
      subcategory: [
        { id: 22, name: "Jersey", slug: "men-jersey" },
        { id: 23, name: "Shorts", slug: "men-shorts" },
        { id: 24, name: "Tank top", slug: "men-tank-top" },
      ],
    },
    {
      id: 2,
      name: "Cycling",
      slug: "men-cycling",
      subcategory: [
        { id: 25, name: "Cycling Jersey", slug: "men-cycling-jersey" },
        { id: 26, name: "Race fit jersey", slug: "men-race-fit-jersey" },
        { id: 27, name: "Winter jersey", slug: "men-winter-jersey" },
        { id: 29, name: "Shorts", slug: "men-cycling-shorts" },
        { id: 30, name: "Tees", slug: "men-tees" },
      ],
    },
    {
      id: 3,
      name: "Cricket",
      slug: "men-cricket",
      subcategory: [
        { id: 31, name: "City collection", slug: "men-city-collection" },
        { id: 32, name: "Jersey", slug: "men-cricket-jersey" },
        { id: 33, name: "Shorts", slug: "men-cricket-shorts" },
        { id: 34, name: "Track pants", slug: "men-track-pants" },
        { id: 35, name: "Whites", slug: "men-whites" },
      ],
    },
    {
      id: 4,
      name: "Running",
      slug: "men-running",
      subcategory: [
        { id: 36, name: "X jersey", slug: "men-x-jersey" },
        { id: 37, name: "Pro jersey", slug: "men-pro-jersey" },
        {
          id: 38,
          name: "Pro tank top jersey",
          slug: "men-pro-tank-top-jersey",
        },
        { id: 39, name: "Shorts", slug: "men-running-shorts" },
      ],
    },
    {
      id: 5,
      name: "Fitness",
      slug: "men-fitness",
      subcategory: [
        { id: 40, name: "Basic T shirt", slug: "men-basic-t-shirt" },
        { id: 41, name: "Pro T shirt", slug: "men-pro-t-shirt" },
        { id: 42, name: "Woven Shorts", slug: "men-woven-shorts" },
        { id: 43, name: "Compression pants", slug: "men-compression-pants" },
        { id: 44, name: "Knitted shorts", slug: "men-knitted-shorts" },
        {
          id: 45,
          name: "Fitness Pro T shirt",
          slug: "men-fitness-pro-t-shirt",
        },
        { id: 46, name: "Singlet", slug: "men-singlet" },
      ],
    },
    {
      id: 6,
      name: "Basketball",
      slug: "men-basketball",
      subcategory: [
        { id: 47, name: "Arm sleeves", slug: "men-arm-sleeves" },
        { id: 48, name: "Jersey", slug: "men-basketball-jersey" },
        { id: 49, name: "Shorts", slug: "men-basketball-shorts" },
      ],
    },
    {
      id: 7,
      name: "Football",
      slug: "men-football",
      subcategory: [
        { id: 50, name: "Jersey", slug: "men-football-jersey" },
        { id: 51, name: "Shorts", slug: "men-football-shorts" },
      ],
    },
  ];
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

//   const threeDglbArray= [
//               {
// customize_file: "uploads/category/customize/0150720251752581417.glb",
// customize_image: "uploads/category/customize/images/0150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/0150720251752583187.svg",
// id: 51},
// {
//   customize_file: "uploads/category/customize/1150720251752581417.glb",
// customize_image: "uploads/category/customize/images/1150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/1150720251752583187.svg",
// id: 52
// },
// {
  
// customize_file: "uploads/category/customize/2150720251752581417.glb",
// customize_image: "uploads/category/customize/images/2150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/2150720251752583187.svg",
// id: 53
// },
// {
//   customize_file: "uploads/category/customize/3150720251752581417.glb",
// customize_image: "uploads/category/customize/images/3150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/3150720251752583187.svg",
// id: 54
// },{
//   customize_file: "uploads/category/customize/4150720251752581417.glb",
// customize_image: "uploads/category/customize/images/4150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/4150720251752583187.svg",
// id: 55
// },{
//   customize_file: "uploads/category/customize/5150720251752581417.glb",
// customize_image: "uploads/category/customize/images/5150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/5150720251752583187.svg",
// id: 185
// },
// {
//   customize_file: "uploads/category/customize/6150720251752581417.glb",
// customize_image: "uploads/category/customize/images/6150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/6150720251752583187.svg",
// id: 193
// },{
//   customize_file: "uploads/category/customize/7150720251752581417.glb",
// customize_image: "uploads/category/customize/images/7150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/7150720251752583187.svg",
// id: 194
// },{
  
// customize_file: "uploads/category/customize/8150720251752581417.glb",
// customize_image: "uploads/category/customize/images/8150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/8150720251752583187.svg",
// id: 235
// },{
  
// customize_file: "uploads/category/customize/9150720251752581417.glb",
// customize_image: "uploads/category/customize/images/9150720251752581417.png",
// customize_svg: "uploads/category/customize/svg/9150720251752583187.svg",
// id: 236
// }

//             ]
  // const { tokenDetails } = useSelector((state) => state.user);
  const [menu, setMenu] = useState(staticMenu);
  const [menuSlugName, setMenuSlugName] = useState("");
  const [menuSubcategory, setmenuSubcategory] = useState("");
  const [menuSlug, setMenuSlug] = useState(staticCategory);
  const [product, setProduct] = useState([]);
  const [cartProduct, setCartProduct] = useState([]);
  const [glb, setGlb] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [hoveredItemIndex, setHoveredItemIndex] = useState(null);
  const [hover,setHover]=useState(null)
  const { favorites } = useSelector((state) => state.cart);
  const totalFavorites = favorites.length;
  const [topText,setTopText]=useState([])
 const dispatch=useDispatch()
  const { totalItems } = useSelector((state) => state.cart);
  console.log("totalItems : ", totalItems);
  const { tokenDetails } = useSelector((state) => state.user);

  const [offers, setOffers] = useState([]);
  const [index, setIndex] = useState(0);
    const modelItems=useSelector((state)=>state.cart.modelItems);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await menuSection();
        const response1 = await offer_Api();
        console.log("response1 : ", response1);
        setTopText(response1.data)

        if (response.success === true) {
          // setMenu(response.data);
        }

        if (response1.success === true) {
          setOffers(response1.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMenu();
  }, []);

  // const handle3d = async() => {
  //   console.log("Don");

  //   // if (!tokenDetails) {
  //   //   toast.error("Please login or signup");
  //   //   return;
  //   // }
    
  //    await navigate("/3d-product", {
  //         state: {
  //           menuSlug: "men",
  //           // subcategorySlug: "men-cricket-jersey",
  //           subcategorySlug: "men-jersey",
  //           glbFile: null,
  //         },
  //       })
  // };

  const handle3d = async () => {
  console.log("🎨 Design Your Own clicked");
  
  // Check if we're currently on the 3D page
  const isOn3DPage = window.location.pathname.includes("/3d-product");
  
  if (isOn3DPage) {
    console.log("📍 Already on 3D page - Resetting customization only");
    
    // Reset only customization, keep current model
    // state.updateTrigger++;
    // state.color = "";
    // state.frontText = "";
    // state.backText = "";
    // state.frontNumber = "";
    // state.backNumber = "";
    // state.frontLogo = "";
    // state.backLogo = "";
    // state.imagesPattern = {};
    // state.selectedPattern = {};
    // state.partColors = {};
    // state.gradientColors = {};
  } else {
    console.log("🔄 Not on 3D page - Opening default model");
    
    // Navigate to 3D page with DEFAULT model
    navigate("/3d-product", {
      state: {
        menuSlug: "men",
        subcategorySlug: "men-jersey",
        glbFile: null,
        isNewSession: true, // Flag for new session
        timestamp: Date.now(),
      }
    });
  }
};


  const [clickedSubItemId, setClickedSubItemId] = useState(null);

  const [clickedItemIndex, setClickedItemIndex] = useState(null);

  //mobile view
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [expandedMenuIndex, setExpandedMenuIndex] = useState(null);
  const [expandedSubMenuIndex, setExpandedSubMenuIndex] = useState(null);

   const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsAtTop(true);
      } else {
        setIsAtTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isMenuOpen) {
      // Reset expanded menus when closing
      setExpandedMenuIndex(null);
      setExpandedSubMenuIndex(null);
    }
  };

  // Prevent scrolling when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

  //  useEffect(() => {
  //     const handleResize = () => {
  //       setIsMobileView(window.innerWidth <= 768);
  //     };
  //     window.addEventListener('resize', handleResize);
  //     return () => window.removeEventListener('resize', handleResize);
  //   }, []);
  //end movile view

  const clickHandler = async (name, slug,index) => {
    try {
      setHoveredItemIndex(index)
      // setMenuSlug([]);
      console.log("enter name : ", slug);
       setMenuSlugName(slug);
      const formData = new FormData();
      formData.append("slug", slug);
      const response = await menuSlugSection(formData);

      if (response.success === true) {
        setMenuSlug(response.data.category || []);
        console.log("API response menuSlugSection :", response);
      }
    } catch (error) {
      console.error("Error during API call:", error);
      setMenuSlug([]);
    }
  };

  const clickProductHandler = async (item, item2, name, menu, categoryName) => {
    console.log("item : ", item);
    if (!menuSlugName || !name) {
      console.error("Invalid slugs provided:", { menuSlugName, name });
      return;
    }

    console.log("menuSlug:", menuSlugName, "categorySlug:", name);
    console.log("categoryName : ", categoryName);
    console.log("category : ", item2.name);
    console.log("subcategory : ", item.name);
    navigate(
      `/productListing/${menuSlugName}/${name}/${menu}/${item2.name}/${item?.id}/${item.name}`
    );
    toggleMobileMenu();
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setClickedItemIndex(null); // Close dropdown
      }
    };

    if (clickedItemIndex !== null) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [clickedItemIndex]);

  const ImageSkeleton = ({ width = "150px", height = "300px" }) => {
    return (
      <div
        style={{
          width,
          height,
          background:
            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.5s infinite",
        }}
      />
    );
  };

   const texts = ["This is the first sentence", "This is the second sentence","This is the first sentence", "This is the second sentence"];

    useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 2000); // change every 2 seconds
    return () => clearInterval(interval);
  }, []);


  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
     
     {/* {window.innerWidth>567 &&  <motion.div style={{backgroundColor:"white",color:"black",position:isAtTop?"fixed":"relative",maxHeight:"30px",opacity:window.innerWidth<567?0:1,
        top:0,zIndex:99000,padding:"5px",width:"50%",display:"flex",marginBottom:"10px",height:"30px",
        justifyContent:"center",borderBottomLeftRadius:"10px",borderBottomRightRadius:"10px",borderRadius:"10px"}}>
      
         <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-100%", opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          style={{height:"15px",fontSize:"12px",fontFamily:"Poppins"}}
        >
          {topText[index]?.message||texts[index]}
        </motion.div>
      </AnimatePresence>
      </motion.div>}

    {window.innerWidth<567 &&  <motion.div style={{backgroundColor:"black",color:"white",position:"fixed",maxHeight:"30px",
        top:0,zIndex:99000,padding:"5px",width:"100%",display:"flex",marginBottom:"10px",height:"30px",
        justifyContent:"center",}}>
      
         <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-100%", opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          style={{height:"15px",fontSize:"12px",fontFamily:"Poppins"}}
        >
          {topText[index]?.message||texts[index]}
        </motion.div>
      </AnimatePresence>
      </motion.div>} */}

      <header

        onMouseLeave={() => {setHoveredItemIndex(null)
                                  }}
        className="header-main"
        style={{ position: "fixed",background:"white", top:window.innerWidth<567?0 :isAtTop?"31px":0,transform:"0.3s ease",
          margin:window.innerWidth<567?"25px":0,zIndex:1000,
           width:window.innerWidth<567?"100vw": "90vw",paddingLeft:window.innerWidth<567?0:"25px",paddingRight:window.innerWidth<567?0:"24px",borderRadius:"8px", border: "1px solid rgba(255, 255, 255, 0.3)",
             boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
          // backgroundColor: "rgba(102, 105, 101, 0.4)", 
          height:"fit-content"}}
      >
    

        <div className="block-container-2 header-block">
          <div
            style={{ position: "relative",backgroundColor:"transparent", display:"flex", alignItems:"center",justifyContent:"space-between" }}
            className={`header-full-section align-items-center header-row ${
              isMobileMenuOpen ? "mobile-align-items-center" : ""
            }`}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="d-icon">
                <div className="">
                  <button
                    // className={"btn nav-main-toggle-btn header-actions-btn"}
                    onClick={toggleMobileMenu}
                    aria-label="Menu"
                    style={{ background: "transparent" }}
                  >
                    <MdOutlineMenu
                      className=""
                      style={{
                        color: "black",
                        fontSize:window.innerWidth<567?"20px": "31px",
                        marginBottom: "0px",
                        marginRight: "7px",
                        marginTop: "6px",
                        background: "transparent",
                      }}
                    />
                  </button>
                </div>
              </div>
              <div
                className="header-logo-col"
                style={{
                  width: "max-content",
                  position: "relative",
                  marginLeft: "30px",
                }}
              >
                <div className="header-logo-main">
                  <Link to="/">
                    <img
                      className="header-logo-img"
                      src="/asset/LogoSports.png"
                      alt="Sports"
                      style={{width:window.innerWidth<567?"100px":"100px",height:window.innerWidth<567?"40px":"40px"}}
                    />
                  </Link>
                </div>
              </div>
            </div>

            <div className={`${"header-nav-box"}`}
           
            >
              <div className="main-navigation d-lg-block" id="mainNavigation">
                <div className="container">
                  <nav
                    className="nav main-navigation-menu default"
                    itemScope="itemscope"
                    itemType="http://schema.org/SiteNavigationElement"
                  >
                    <div className="main-navigation-menu-container">
                      <div style={{ width: "100%" }}>
                        <div
                          className="nav-link main-navigation-link"
                          title="Sports"
                          style={{ width: "100%", padding: "0px" }}
                        >
                          <div
                            className={`${
                              isMobileMenuOpen
                                ? "main-navigation-link-text mobile-main-navigation-link-text"
                                : "main-navigation-link-text"
                            }`}
                          >
                            {menu?.map((item1, index) => (
                              <div
                                className={`${
                                  item1.name === "Design your own"
                                    ? "design-your-own"
                                    : ""
                                }`}
                                key={index}
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  position: "relative",
                                  padding: "14px 10px",
                                  
                                }}
                                
                                onMouseEnter={() => {
                                   setHover(index)
                                    
                                  
                                  // else{
                                  //  handle3d();
                                  // }
                                }}
                                onMouseLeave={() => {setHover(null)
                                  }}

                                ref={
                                  hoveredItemIndex === index
                                    ? dropdownRef
                                    : null
                                }
                                onClick={() => {
                                  if (item1.name === "Design your own") {
                                    handle3d();
                                  } else if (item1.name === "Team Order") {
                                    navigate("/team-order");
                                  } else if (item1.name === "Family Order") {
                                    navigate("/family-order");
                                  } else if (item1.name === "Event Order") {
                                    navigate("/event-order");
                                  }
                                   if (
                                    item1.name !== "Design your own" ||
                                    item1.name !== "Team Order" ||
                                    item1.name !== "Family Order"
                                  ) {
                                    clickHandler(item1.name, item1.slug,index);
                                  }

                                }}
                              >
                                {/* {item1.name === "Design your own" && (
                                  <div className="yellow-bg"></div>
                                )} */}
                                <span
                                  style={{
                                    color: "black",
                                    width: "100%",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    position: "relative",
                                  }}
                                >
                                  {item1.name}
                                  {item1.name === "Design your own" && (
                                    <span
                                      className="yellow-highlight"
                                      style={{
                                        position: "absolute",
                                        top: "0",
                                        left: "0",
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "#FCF300",
                                        // borderRadius: "20px",
                                        zIndex: "-1",
                                        transform: "rotate(-1deg)",
                                        opacity: "0.8",
                                        animation:
                                          "pulse 2s infinite alternate, shine 4s linear infinite",
                                        boxShadow:
                                          "0 0 10px rgba(255,215,0,0.5)",
                                        backgroundSize: "200% auto",
                                      }}
                                    />
                                  )}
                                  {hover === index && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        bottom: "-5px",
                                        left: "0",
                                        width: "100%",
                                        height: "3px",
                                        backgroundColor: "black",
                                      }}
                                    />
                                  )}
                                </span>

                                {item1.name !== "Design your own" &&
                                  item1.name !== "Team Order" &&
                                  item1.name !== "Event Order" && // Add this condition
                                  item1.name !== "Family Order" &&
                                  hoveredItemIndex === index &&
                                  Array.isArray(menuSlug) &&
                                  menuSlug.length > 0 && (
                                    <ul
                                      className={`dropdown-menu1 ${
                                        hoveredItemIndex === index ? "show" : ""
                                      }`}
                                  //     onMouseLeave={() => {setHoveredItemIndex(null)
                                  // }}
                                      style={{
                                        position: "fixed",
                                        top: "55px",
                                        left: "0",
                                        right: "0",
                                        zIndex: 10,
                                        backgroundColor: "#fff",
                                        boxShadow:
                                          "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        padding: "20px",
                                        width: "100%",
                                        height: "350px",

                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <div
                                        className="dropdown-height"
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          flexWrap: "wrap",
                                          height: "100%",
                                        }}
                                      >
                                        <p style={{fontSize:"15px",marginLeft:"20px",fontWeight:600,borderBottom:"1px Solid black",color:"black",width:"fit-content"}}>
                                          {item1.name}</p>
                                        {menuSlug?.map((item) => (
                                          <li
                                            key={item.id}
                                            className="dropdown-item"
                                          >
                                            <div className="deropdown-item-list">
                                              <strong
                                                onClick={() => {
                                                  setmenuSubcategory(item.slug);
                                                  clickProductHandler(
                                                    item,
                                                    item1,
                                                    item.slug,
                                                    item1.slug,
                                                    item.slug
                                                  );
                                                  setHoveredItemIndex(null);
                                                }}
                                                style={{
                                                  fontSize: "12px",
                                                  color: "black",
                                                }}
                                              >
                                                {item.name}
                                              </strong>
                                              <ul className="list-unstyled">
                                                {item.subcategory?.map(
                                                  (subItem) => (
                                                    <li
                                                      key={subItem.id}
                                                      className={
                                                        clickedSubItemId ===
                                                        subItem.id
                                                          ? "bg-blue"
                                                          : ""
                                                      }
                                                    >
                                                      <a
                                                        className="text-decoration-none sub-item-link"
                                                        onClick={() => {
                                                          setmenuSubcategory(
                                                            subItem.slug
                                                          );
                                                          clickProductHandler(
                                                            subItem,
                                                            item,
                                                            subItem.slug,
                                                            item1.slug,
                                                            item.slug
                                                          );
                                                          setHoveredItemIndex(
                                                            null
                                                          ); // Close dropdown after click
                                                        }}
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        {subItem.name}
                                                      </a>
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            </div>
                                          </li>
                                        ))}
                                      </div>
                                      <div
                                        style={{ display: "flex", gap: "10px" }}
                                      >
                                        <div
                                          className="dropdown-image"
                                          style={{ position: "relative" }}
                                        >
                                          {!image17Loaded && <ImageSkeleton />}
                                      
                                          <img
                                            src={item1.name==="Men"?"/asset/img/Ecom/Mens banner 1.jpg":
                                              item1.name==="Women"?"/asset/img/Ecom/Women banner 1.jpg":
                                            "/asset/img/Ecom/17.webp"}
                                            alt="Product"
                                            style={{
                                              objectFit: "cover",
                                              height: "300px",
                                              display: image17Loaded
                                                ? "block"
                                                : "none",
                                            }}
                                            onLoad={() =>
                                              setImage17Loaded(true)
                                            }
                                          />
                                        </div>

                                        <div
                                          className="dropdown-image"
                                          style={{ position: "relative" }}
                                        >
                                          {!image21Loaded && <ImageSkeleton />}
                                       
                                          <img
                                            src={item1.name==="Men"?"/asset/img/Ecom/Mens banner 2.jpg":
                                              item1.name==="Women"?"/asset/img/Ecom/Women-banner-2.jpg":
                                            "/asset/img/Ecom/21.webp"}
                                            alt="Product"
                                            style={{
                                              objectFit: "cover",
                                              height: "300px",
                                              display: image21Loaded
                                                ? "block"
                                                : "none",
                                            }}
                                            onLoad={() =>
                                              setImage21Loaded(true)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </ul>
                                  )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>

            <div
              className={`header-action-box ${
                isMobileMenuOpen
                  ? "header-action-box mobile-header-action-box"
                  : ""
              }`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "0px",
                flexDirection: "row-reverse",
                
              }}
            >
              <AccountSec />
              
              <div
                className="boxHover-container"
                onClick={() => (window.location.href = "/cart")}
                style={{
                  cursor: "pointer",
                  width: "35px",
                  height: "29px",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FiShoppingCart />
                {tokenDetails && totalItems > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "-13px",
                      right: "-14px",
                      backgroundColor: "#ff0000",
                      color: "white",
                      borderRadius: "50%",
                      padding: "0 6px",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    {totalItems}
                  </div>
                )}
              </div>
              {/* <div
                className="boxHover-container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25px",
                  height: "29px",
                  position: "relative",
                }}
                onClick={() => navigate("/wishlist")}
              >
                <FaRegHeart />
                {tokenDetails && totalFavorites > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "-13px",
                      right: "-14px",
                      backgroundColor: "#ff0000",
                      color: "white",
                      borderRadius: "50%",
                      padding: "0 6px",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    {totalFavorites}
                  </div>
                )}
              </div> */}
            </div>
          </div>
        </div>
      </header>








      {/* Mobile Navigation (hidden on desktop) */}
      <div
        className={`mobile-menu-overlay ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMobileMenu}
      ></div>

      <div className={`mobile-navigation ${isMenuOpen ? "open" : ""}`} 
      style={{zIndex:10000,top:0,height:"100vh"}}>
        <div>
          <img src="/asset/img/navbar-banner.jpg" style={{objectFit:"cover"}}/>
          <div className="" onClick={toggleMobileMenu} style={{position:"absolute",top:"10px",right:"10px",cursor:"pointer",backgroundColor:"white",borderRadius:"50%",padding:"5px"}}>
          <FaTimes style={{ fontSize: "20px" }} />
        </div>
        </div>
        
        <div className="mobile-menu-content">
          {menu?.map((item1, index) => (
            <div key={index} className="mobile-menu-item">
              {item1.name === "Design your own" ||
              item1.name === "Team Order" ||
              item1.name === "Event Order" ||
              item1.name === "Family Order" ? (
                <div
                  className="mobile-menu-header"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item1.name === "Design your own") {
                      toggleMobileMenu();
                      handle3d();
                    } else if (item1.name === "Team Order") {
                      toggleMobileMenu();
                      navigate("/team-order");
                    } else if (item1.name === "Family Order") {
                      toggleMobileMenu();
                      navigate("/family-order");
                    } else if (item1.name === "Event Order") {
                      toggleMobileMenu();
                      navigate("/event-order");
                    }
                  }}
                >
                  <span className="mobile-menu-title">{item1.name}</span>
                </div>
              ) : (
                <>
                  <div
                    className="mobile-menu-header"
                    onClick={() => {
                      clickHandler(item1.name, item1.slug);
                      setExpandedMenuIndex(
                        expandedMenuIndex === index ? null : index
                      );
                    }}
                  >
                    <span className="mobile-menu-title" style={{borderLeft:expandedMenuIndex === index?"3px solid #025710ff":"none",paddingLeft:expandedMenuIndex === index?"7px":0}}>
                      {item1.name}</span>
                    <span className="mobile-menu-icon">
                      {expandedMenuIndex === index ? (
                        <FaAngleUp style={{ fontSize: "16px" }} />
                      ) : (
                        <FaAngleDown style={{ fontSize: "16px" }} />
                      )}
                    </span>
                  </div>

                  {/* Show dropdown for ALL regular menu items, not just "Event Order" */}
                  <div
                    className={`mobile-dropdown-container ${
                      expandedMenuIndex === index ? "expanded" : ""
                    }`}
                  >
                    <div className="mobile-dropdown">
                      {menuSlug?.map((item) => (
                        <div key={item.id} className="mobile-dropdown-item" style={{paddingBottom:"6.5px"}}>
                          <div
                            className="mobile-dropdown-header"
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedSubMenuIndex(
                                expandedSubMenuIndex === item.id
                                  ? null
                                  : item.id
                              );
                            }}
                          >
                            <strong
                            style={{color:"#494949ff"}}
                              className="mobile-dropdown-title"
                            >
                              {item.name}
                            </strong>
                            {item.subcategory?.length > 0 && (
                              <span className="mobile-dropdown-icon">
                                {expandedSubMenuIndex === item.id ? (
                                  <FaAngleUp style={{ fontSize: "12px" }} />
                                ) : (
                                  <FaAngleDown style={{ fontSize: "12px" }} />
                                )}
                              </span>
                            )}
                          </div>

                          <div
                            className={`mobile-submenu-container ${
                              expandedSubMenuIndex === item.id &&
                              item.subcategory?.length > 0
                                ? "expanded"
                                : ""
                            }`}
                          >
                            {expandedSubMenuIndex === item.id &&
                              item.subcategory?.length > 0 && (
                                <div className="mobile-submenu">
                                  {item.subcategory.map((subItem) => (
                                    <div
                                      key={subItem.id}
                                      className="mobile-submenu-item"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setmenuSubcategory(subItem.slug);
                                        clickProductHandler(
                                          subItem,
                                          item,
                                          subItem.slug,
                                          item1.slug,
                                          item.slug
                                        );
                                      }}
                                    >
                                      {subItem.name}
                                    </div>
                                  ))}
                                </div>
                              )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .mobile-menu-close {
          position: absolute;
          top: 0px;
          right: 19px;
          cursor: pointer;
          z-index: 1000;
          padding: 5px;
          color: #333;
        }

        .mobile-navigation {
          position: fixed;
          top: 71px; /* Height of your header */
          left: -100%;
          width: 85%;
          max-width: 450px;
          height: calc(100vh - 76px); /* Subtract header height */
          background-color: white;
          z-index: 999;
          overflow-y: auto; /* Enable vertical scrolling */
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
        }

        .mobile-menu-content {
          padding: 20px 15px;
          height: 100%; /* Take full height of parent */
          overflow-y: auto; /* Enable scrolling for content */
        }

        .mobile-navigation.open {
          left: 0;
        }

        .mobile-menu-content {
          padding: 20px 15px;
        }

        .mobile-menu-item {
          border-bottom: 1px solid #eee;
        }

        .mobile-menu-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 10px;
          cursor: pointer;
        }

        .mobile-menu-title {
          color: black;
          font-size: 14px;
          font-weight: bold;
        }

        .mobile-menu-icon {
          font-size: 15px;
          font-weight: bold;
        }

        .mobile-dropdown-container {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }

        .mobile-dropdown-container.expanded {
          max-height: 1000px;
        }

        .mobile-dropdown {
          padding-left: 15px;
        }

        .mobile-dropdown-item {
          border-bottom: 1px solid #f5f5f5;
          padding: 3px 0;
        }

        .mobile-dropdown-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          font-size: 13px;
        }

        .mobile-dropdown-title {
          font-size: 13px;
          color: black;
        }

        .mobile-dropdown-icon {
          font-weight: bold;
        }

        .mobile-submenu-container {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }

        .mobile-submenu-container.expanded {
          max-height: 1000px;
        }

        .mobile-submenu {
          padding-left: 15px;
          background-color: #f9f9f9;
          border-radius: 4px;
          margin-top: 5px;
        }

        .mobile-submenu-item {
          padding: 3px 0;
          font-size: 12px;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .mobile-submenu-item:hover {
          background-color: #f0f0f0;
        }
      `}</style>
    </div>
  );
}

export default Header;
